<template>
<div class="services-section">
  <div class="container">
    <div class="services-section-header">
      <h2 class="thin">How <span class="bold">I can help</span> you</h2>
      <p>I will create a custom program to help you reach your goals using a combination of metabolic conditioning and weight training.</p>
      <p>I offer several options to help you kick ass.</p>
    </div>
    <div class="row services-cards">
      <div class="col-md-6 col-xl-3">
        <div class="card">
          <img class="card-img-top" src="../assets/img/service/personal-training.jpg" alt="">
          <div class="card-body">
            <h3 class="card-title">Personal Training</h3>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-3">
        <div class="card">
          <img class="card-img-top" src="../assets/img/service/beach-built-hiit-classes.jpg" alt="">
          <div class="card-body">
            <h3 class="card-title">Beach-Built HIIT Classes</h3>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-3">
        <div class="card">
          <img class="card-img-top" src="../assets/img/service/nutrition-classes.jpg" alt="">
          <div class="card-body">
            <h3 class="card-title">Nutrition Classes</h3>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-3">
        <div class="card">
          <img class="card-img-top" src="../assets/img/service/accountability-program.jpg" alt="">
          <div class="card-body">
            <h3 class="card-title">Accountability Program</h3>
          </div>
        </div>
      </div>
    </div>

    <router-link :to="{ name: 'services' }" class="btn btn-light">
      view details
    </router-link>

  </div>
  <div class="wave-bottom">
    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="140px" viewBox="20 -20 300 100" xml:space="preserve">
      <path class="fill-body-bg" opacity="0.4" d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729 c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z"></path>
      <path class="fill-body-bg" opacity="0.4" d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729 c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z"></path>
      <path class="fill-body-bg" opacity="0" d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716 H42.401L43.415,98.342z"></path>
      <path class="fill-body-bg" d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428 c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z"></path>
    </svg>
  </div>
</div>
</template>

<script>
export default {

}
</script>
